import { Suspense } from "react";
import { createBrowserRouter, Navigate, RouterProvider } from "react-router";
import { OverviewComponent, protectedRoutes, publicRoutes } from "./Routes";
import { PageNotFound } from "shared/dist/components";
import LinearProgress from "@mui/material/LinearProgress";
import AnalyticsTracker from "../Services/Analytics/googleAnalitic";

const AuthGuard = ({ isAuthenticated, children }) => {
    if (!isAuthenticated) {
        return <Navigate to="/login" replace />;
    }
    return children;
};

const createRouter = (isAuthenticated) => {
    if (!protectedRoutes || !publicRoutes) return null;

    const routes = [
        ...Object.values(publicRoutes),
        ...Object.values(protectedRoutes).map((route) => ({
            ...route,
            element: <AuthGuard isAuthenticated={isAuthenticated}>{route.element}</AuthGuard>,
        })),
        { path: "*", element: <PageNotFound /> },
        { index: true, element: <OverviewComponent /> },
    ];

    return createBrowserRouter([{ element: <AnalyticsTracker />, children: routes }]);
};

export const Router = ({ isAuthenticated }) => {
    const router = createRouter(isAuthenticated);

    return (
        <Suspense fallback={<LinearProgress />}>
            <RouterProvider router={router} />
        </Suspense>
    );
};
